// Photo de profil d'équipe (D-060) : choisie par le staff, sinon le dernier selfie de victoire.
// Un rond en tête de la page équipe et de l'onglet Matchs ; le staff la change d'un tap.
import { teamPhoto, teamSetPhoto, type Team } from '../lib/api';
import { $, html, mount, openSheet, toast } from './dom';
import { photoToJpeg } from './match-extras';

export async function renderTeamPhoto(el: HTMLElement, team: Team, staff: boolean, onChange?: () => void): Promise<void> {
  const p = await teamPhoto(team.id).catch(() => null);
  const initials = team.name.split(/\s+/).map(w => w.charAt(0)).join('').slice(0, 3).toUpperCase();
  const face = p ? html`<img src="data:image/jpeg;base64,${p.data}" alt="Photo de l'équipe ${team.name}">` : html`<span aria-hidden="true">${initials}</span>`;
  mount(el, staff
    ? html`<button type="button" class="tph" id="tph" aria-label="Photo de l'équipe : changer">${face}<i aria-hidden="true">✎</i></button>`
    : html`<span class="tph">${face}</span>`);
  $(el, '#tph')?.addEventListener('click', () => {
    openSheet('Photo de l’équipe', html`
      ${p ? html`<img class="mx-preview" src="data:image/jpeg;base64,${p.data}" alt="">` : ''}
      <p class="muted small">${p?.source === 'team' ? 'Photo choisie par le staff.' : p ? 'Pour l’instant : le dernier selfie de victoire.' : 'Pas encore de photo : le dernier selfie de victoire la remplacera tout seul.'}</p>
      <label class="btn btn-primary">Choisir une photo<input type="file" accept="image/*" id="tph-file" hidden></label>
      ${p?.source === 'team' ? html`<button type="button" class="btn btn-ghost" id="tph-reset">Revenir au dernier selfie de victoire</button>` : ''}`, (sheet, close) => {
      $<HTMLInputElement>(sheet, '#tph-file')!.addEventListener('change', async e => {
        const f = (e.target as HTMLInputElement).files?.[0];
        if (!f) return;
        try { await teamSetPhoto(team.id, await photoToJpeg(f, 800, 0.82)); close(); toast('Photo de l’équipe changée'); void renderTeamPhoto(el, team, staff, onChange); onChange?.(); }
        catch { toast('Photo impossible (trop lourde ?).', 'ko'); }
      });
      $(sheet, '#tph-reset')?.addEventListener('click', async () => {
        try { await teamSetPhoto(team.id, null); close(); void renderTeamPhoto(el, team, staff, onChange); onChange?.(); } catch { toast('Impossible.', 'ko'); }
      });
    });
  });
}
